import { Typography } from "antd";

import { RVDebouncedInput } from "../../atoms/RVDebouncedInput/RVDebouncedInput";

import styles from "./RVHeaderInputFilterCount.module.scss";

type RVHeaderInputFilterCountProps = {
    setFilterValue: (value: string) => void;
    defaultSearch?: string;
    count: number;
    placeholder?: string;
    inputId?: string;
};
/**
 * RVHeaderInputFilterCount
 *
 * Displays a debounced search input and a count of applied filters.
 * Used in grid/table headers to show how many filters are active.
 *
 * @param {Object} props - Component props
 * @param {number} props.count - Number of filters currently applied
 * @param {(value: string) => void} props.setFilterValue - Callback to set the filter value
 * @param {string} [props.defaultSearch] - Default value for the search input
 * @param {string} [props.placeholder] - Placeholder text for the search input
 * @returns {JSX.Element}
 */

export const RVHeaderInputFilterCount = ({
    count,
    setFilterValue,
    defaultSearch,
    placeholder = "Search by name",
    inputId,
}: RVHeaderInputFilterCountProps) => {
    return (
        <div className={styles.actionInputContainer}>
            <RVDebouncedInput
                className={styles.searchInput}
                action={setFilterValue}
                placeholder={placeholder}
                defaultValue={defaultSearch}
                data-testid={inputId}
            />
            {count > 0 && (
                <Typography.Text className={styles.filterCount}>
                    {count} {count == 1 ? "filter" : "filters"} applied
                </Typography.Text>
            )}
        </div>
    );
};
